// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"541":"7298908e","702":"7298908e","783":"2f01a02f","995":"7298908e"}[chunkId] + ".chunk.css";
};